var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.675 27.38H9.2a1.206 1.206 0 0 0-1.046 1.81l4.74 8.207a1.206 1.206 0 0 0 2.089 0l4.738-8.208a1.206 1.206 0 0 0-1.045-1.81m.262-10.661c0 1.223-.996 2.219-2.22 2.219h-5.561a2.222 2.222 0 0 1-2.22-2.22v-5.56c0-1.225.996-2.22 2.22-2.22h5.562c1.223 0 2.219.995 2.219 2.22v5.56zm.072-14.781H8.864a6.928 6.928 0 0 0-6.927 6.928v10.144a6.927 6.927 0 0 0 6.927 6.928H19.01a6.928 6.928 0 0 0 6.928-6.928V8.865a6.928 6.928 0 0 0-6.928-6.928z",
    fill: "#FC5726",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerOrange);
export default __webpack_public_path__ + "static/media/markerOrange.f3fb619852ae62ade80bb26ea51723ea.svg";
export { ForwardRef as ReactComponent };